import axios, { AxiosInstance } from "axios";

let baseURL: string | undefined;

switch (process.env.NODE_ENV) {
  case "development":
    baseURL = process.env.REACT_APP_API_URL_DEV;
    break;
  case "production":
    baseURL = process.env.REACT_APP_API_URL_PROD;
    break;
  case "test":
    baseURL = process.env.REACT_APP_API_URL_TEST;
    break;
  default:
    throw new Error(`Unknown NODE_ENV: ${process.env.NODE_ENV}`);
}

const ACTIVE_AGENCY_STORAGE_KEY = "activeAgencyId";

const authToken = localStorage.getItem("authToken") || "";

export const apiClient: AxiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${authToken}`,
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }

    // Attach the active agency id so the backend's ResolveAgencyContext
    // middleware can scope the request to the selected agency.
    // Read directly from localStorage to keep this interceptor independent of
    // any cyclic store import.
    try {
      const activeAgencyId = localStorage.getItem(ACTIVE_AGENCY_STORAGE_KEY);
      if (activeAgencyId) {
        config.headers["X-Agency-Id"] = activeAgencyId;
      } else if (config.headers["X-Agency-Id"]) {
        delete config.headers["X-Agency-Id"];
      }
    } catch {
      /* localStorage may be unavailable in private modes */
    }

    // Let the browser set Content-Type automatically for FormData (includes boundary)
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");

      // Carry the current page across the forced sign-in, so an expired token does not
      // cost the user their place — deep links from email would otherwise be lost here
      // even though PrivateRoute preserves them.
      const here = `${window.location.pathname}${window.location.search}`;
      const target =
        here.startsWith("/") && !here.startsWith("//") && here !== "/login"
          ? `/login?redirect=${encodeURIComponent(here)}`
          : "/login";

      window.location.href = target;
    }
    return Promise.reject(error);
  },
);
